import capitalizeFirstLetter from './capitalizeFirstLetter';


export default function makeDisplayName(item) {
  let displayName = capitalizeFirstLetter(item.ValidDesignText)

  return displayName.replace(/\//g, ' / ');
}
